import axios from "axios";
import { config } from "../config/index";

const instance = axios.create({
    baseURL: config.baseUrl
});


export default instance;
